var _circle, _circle2, _circle3, _path, _path2, _circle4, _circle5, _circle6, _path3, _path4, _circle7, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyConnections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 251 160",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126.106,
    cy: 82.32,
    r: 44.34,
    fill: "#fff",
    stroke: "#EDEEF2",
    strokeWidth: 0.695
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.65,
    cy: 55.635,
    r: 34.877,
    fill: "#EDEEF2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.995,
    cy: 54.593,
    r: 20.862,
    fill: "#E4E7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.05 64.89l12.175 10.296A20.897 20.897 0 0094.78 61.323L78.494 45.037 67.928 64.89h-1.877z",
    fill: "#D4DAE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.35 54.795c1.347-1.346 2.289-3.567 2.289-5.519 0-3.028-1.077-5.45-4.711-5.45-3.634 0-4.71 2.422-4.71 5.45 0 1.952.941 4.24 2.287 5.519-2.894.673-5.709 2.96-6.718 8.748-.337 1.818 1.346 1.818 1.346 1.818h15.59c.068 0 1.683 0 1.346-1.818-.942-5.787-3.825-8.075-6.718-8.748z",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.649,
    cy: 49.725,
    r: 5.911,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.56,
    cy: 102.595,
    r: 34.877,
    fill: "#EDEEF2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.909,
    cy: 102.595,
    r: 20.862,
    fill: "#E4E7EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.965 112.891l12.174 10.296a20.896 20.896 0 0016.555-13.863l-16.286-16.286-10.566 19.853h-1.877z",
    fill: "#D4DAE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.265 102.797c1.346-1.346 2.288-3.567 2.288-5.519 0-3.028-1.077-5.45-4.711-5.45-3.634 0-4.711 2.422-4.711 5.45 0 1.952.942 4.24 2.288 5.519-2.893.673-5.709 2.961-6.718 8.748-.337 1.817 1.346 1.817 1.346 1.817h15.59c.068 0 1.683 0 1.346-1.817-.942-5.787-3.824-8.075-6.718-8.748z",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.563,
    cy: 97.726,
    r: 5.911,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.387 81.186l1.285-1.284a5.35 5.35 0 000-7.555 5.346 5.346 0 00-7.553 0l-5.23 5.231 1.991 1.992 5.232-5.23c.952-.954 2.615-.954 3.569 0a2.53 2.53 0 01-.001 3.57l-1.285 1.285a1.404 1.404 0 000 1.991c.55.551 1.442.551 1.992 0zm-9.422 3.848l-3.668-3.668v.015c0 1.426.555 2.77 1.565 3.778a1.405 1.405 0 002.103-.125z",
    fill: "#BFC0C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.758 85.828l-3.657 3.658a2.531 2.531 0 01-3.571 0 2.528 2.528 0 01.001-3.57l1.286-1.286a1.412 1.412 0 000-1.994 1.412 1.412 0 00-1.992 0l-1.288 1.288a5.349 5.349 0 000 7.553 5.326 5.326 0 003.778 1.561c1.368 0 2.736-.52 3.777-1.561l3.657-3.657-1.991-1.992zm4.522-.857c.414-.767.634-1.63.634-2.527 0-1.428-.556-2.77-1.566-3.778a1.408 1.408 0 10-1.99 1.993 2.505 2.505 0 01.718 2.108l2.204 2.204zM116.798 74.057a1.391 1.391 0 011.967 0l14.559 14.558a1.391 1.391 0 01-1.967 1.967l-14.559-14.558a1.391 1.391 0 010-1.967z",
    fill: "#BFC0C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.749 143.245c-13.412.044-26.46-4.475-37.11-12.852-10.427-8.186-18.045-19.572-21.748-32.507l.53-.158c7.49 26.466 31.475 44.95 58.328 44.95a58.976 58.976 0 0023.389-4.796l.213.524a59.5 59.5 0 01-23.602 4.839zM182.957 63.03c-7.747-24.07-30.405-40.24-56.381-40.24a60.223 60.223 0 00-22.442 4.287l-.204-.482a61.285 61.285 0 0130.103-3.87c10.209 1.253 19.912 5.05 28.167 11.022 10.045 7.313 17.483 17.498 21.27 29.127l-.513.156z",
    fill: "#E6E6E6"
  })));
}
export default __webpack_public_path__ + "fonts/empty-connections-edb9258cac2cdda6ade25ef996363832.svg";
export { SvgEmptyConnections as ReactComponent };